<template>
    <BasicDialog class="spin-the-wheel__dialog">
        <div class="spin-the-wheel__dialog-content">

            <div class="spin-the-wheel__title">
                Spin the Wheel and Win Rewards!
            </div>


            <WheelController ref="spinWheelRef" />


            <button class="spin-the-wheel__start-button rounded-pill" @click="handleSpin" :disabled="spinWheelRef?.isSpinning || cantSpin"
                :loading="spinWheelRef?.isSpinning">
                {{ spinWheelRef?.isSpinning ? 'Spinning...' : 'Spin the Wheel!' }}
            </button>

            
        </div>
        <template #append-bottom>
            <div class="spin-the-wheel__footer">
                <div class="spin-the-wheel__footer-title">
                    <span v-if="spinTheWheelStore.activeWheelRewards.length === 0">No</span>
                    Active Rewards
                </div>
                <div class="spin-the-wheel__footer-rewards">
                    <ActiveWheelRewardsList />
                </div>
            </div>
        </template>
    </BasicDialog>
</template>



<script setup lang="ts">

import { ref, computed } from 'vue';
import { SpinTheWheelStore } from "@/store/SpinTheWheelStore";
import BasicDialog from "@/components/Common/Basic-Dialog.vue";
import WheelTimer from "@/components/SpinTheWheel/WheelTimer.vue";
import WheelController from "@/components/SpinTheWheel/WheelController.vue";
import ActiveWheelRewardsList from '@/components/SpinTheWheel/ActiveRewards/Active-Wheel-Rewards-List.vue';

const spinTheWheelStore = SpinTheWheelStore();
type SpinWheelInstance = InstanceType<typeof WheelController>;
const spinWheelRef = ref<SpinWheelInstance | null>(null);

const handleSpin = async () => {
    await spinWheelRef.value?.spin();
};

const cantSpin = computed(() => {
    return spinTheWheelStore.wheelStatus.cant_spin;
});

</script>